import React from "react";
import { CustomModal } from "../../../../../../components";
import CreateNewServiceComponents from "./componets";
import api from "../../../../../../api";
import { ShowAllServiceModal } from "../..";

type Props = {
  driver: string;
  isOpen: boolean;
  onClose: () => void;
  setModal:React.Dispatch<React.SetStateAction<ShowAllServiceModal>>
};

const CreateNewService: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [viewIndex, setViewIndex] = React.useState<number|null>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [services, setServices] = React.useState<Array<any>>([]);
  const [service, setService] = React.useState<any>();

  const [parentValue, setParentValue] = React.useState({
    _id: "",
    phoneNumber: "",
  });

  const CreateServiceViews: Array<JSX.Element> = [
    <CreateNewServiceComponents.GetOrExistParent
      onClose={onCloseModal}
      onNext={functionGetOrExistParent}
      isLoading={isLoading}
    />,
    <CreateNewServiceComponents.CreateOrUpdateParent
      values={parentValue}
      isLoading={isLoading}
      onSubmit={createOrUpdateParent}
      onClose={onCloseModal}
    />,
    <CreateNewServiceComponents.ShowServiceList
      services={services}
      values={parentValue}
      onClickEdit={onClickEdit}
      onClickCreateService={createOrUpdateService}
      onClickUpdateService={createOrUpdateService}
      setModal={props.setModal}
    />,
    <CreateNewServiceComponents.CreateOrUpdateService
      values={service}
      isLoading={isLoading}
      onClose={onCloseModal}
      onSubmit={onSubmitCreateOrUpdateService}
    />,
  ];

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onCloseModal(): void {
    setViewIndex(0);
    props.onClose();
  }

  function createOrUpdateService(event?: any): void {
    event && setService(event);
    setViewIndex(3);
  }

  async function onSubmitCreateOrUpdateService(event: any): Promise<void> {
    setIsLoading(true);
    const resultApi = await api.post.company.createOrUpdateService({
      ...event,
      driver: props.driver,
      parent: parentValue?._id,
    });
    if (resultApi?.result) {
      const resultCallBack = await api.get.common.getOrExistParent(
        parentValue.phoneNumber
      );
      setParentValue(resultCallBack.result.parent);
      setServices(resultCallBack.result.service);
      setViewIndex(2);
    }
    setIsLoading(false);
  }

  async function functionGetOrExistParent(phoneNumber: string): Promise<void> {
    setIsLoading(true);
    const resultApi = await api.get.common.getOrExistParent(phoneNumber);
    if (resultApi.result?.parent) {
      setParentValue({
        ...resultApi.result?.parent,
        province: resultApi.result?.parent?.parentInformation?.province,
        city: resultApi.result?.parent?.parentInformation?.city,
      });
      setServices(resultApi.result.service);
      setViewIndex(2);
    } else {
      setParentValue({ phoneNumber, _id: "" });
      setViewIndex(1);
    }
    setIsLoading(false);
  }

  async function createOrUpdateParent(values: any): Promise<void> {
    setIsLoading(true);
    const resultApi = await api.post.company.createOrUpdateParent(values);
    console.log(resultApi?.result);
    if (resultApi?.result) {
      setParentValue({
        ...resultApi.result?.parent,
        province: resultApi.result?.parent?.parentInformation?.province,
        city: resultApi.result?.parent?.parentInformation?.city,
      });
      setServices(resultApi.result.service);
      setViewIndex(2);
    }
    setIsLoading(false);
  }

  function onClickEdit(): void {
    setViewIndex(1);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomModal
      open={props.isOpen}
      onClose={onCloseModal}
      label={"ساخت سرویس"}
    >
      {CreateServiceViews[viewIndex as number]}
    </CustomModal>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CreateNewService;
